export enum ProposerType {
  Adult = 'adult',
  Child = 'child',
  Student = 'student',
  Senior = 'senior',
}
